<template>
  <div class="confirm-form">
    <h5 class="text-center">選擇退藥理由</h5>
    <div class="reasons-wrap">
      <div :class="{ 'btn drug-button': true, 'item-selected': selectReason === reason, 'reason-button': true }" 
        v-for="reason, n in returnReasons" 
        @click="setReason(reason)">
        {{ reason }}
      </div>
    </div>
   
    <hr>
    <div class="form-group">
      <div class="row" style="margin: 0">
        <h6 class="col-3 col-form-label">其他</h6>
        <input class="col-9 form-control" type="text" v-model="customReason" placeholder="自訂理由">
      </div>
    </div>
    <div class="button-wrap">
      <button class="btn confirm-button btn-lg" @click="confirmReason">確認理由</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Reason',
  data() {
    return {
      selectReason: '',
      customReason: '',
    };
  },
  computed: {
    instance() {
      return this.$store.state.instance;
    },
    returnReasons() {
      return this.$store.state.generalSetting.return_reason;
    },
  },
  watch: {
    customReason(val) {
      if (val !== '') this.selectReason = '';
    },
  },
  methods: {
    setReason(val) {
      this.selectReason = val;
      this.customReason = '';
    },
    confirmReason() {
      if (this.selectReason === '' && this.customReason === '') {
        this.$store.commit('SET_MESSAGE', { type: 'error', context: '請選擇一項理由或輸入理由' });
      } else {
        if (this.customReason !== '') {
          this.$emit('setReason', this.customReason);
        } else {
          this.$emit('setReason', this.selectReason);
        }
      }
    },
  },
};
</script>

<style lang="sass">
.reasons-wrap
  display: flex
  justify-content: center
  align-items: center
  flex-direction: column;

.reason-button
  width: 70%
  margin: 5px 0

</style>



// WEBPACK FOOTER //
// Reason.vue?eb77bafa